import { hashHistory } from 'react-router'

import commonFetch from '../resources/fetchFunction'
import api from '../api'

// ------------------------------------
// Constants
// ------------------------------------
export const CREDENTIAL_CHANGE = 'CREDENTIAL_CHANGE'
export const CREDENTIAL_REQUEST = 'CREDENTIAL_REQUEST'
export const CREDENTIAL_SUCCESS = 'CREDENTIAL_SUCCESS'
export const CREDENTIAL_FAIL = 'CREDENTIAL_FAIL'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

// ------------------------------------
// Actions
// ------------------------------------
export function credentialChange (value) {
  return {
    type    : CREDENTIAL_CHANGE,
    payload : value
  }
}
const whoamiRequest = (metadata) => {
  return {
    type: CREDENTIAL_REQUEST,
    metadata
  }
}
const whoamiSuccess = (response, metadata) => {
  return {
    type: CREDENTIAL_SUCCESS,
    payload: response,
    metadata
  }
}
const whoamiFail = (error, metadata) => {
  return {
    type: CREDENTIAL_FAIL,
    payload: error,
    error: true,
    metadata
  }
}

const logoutSuccess = () => {
  return {
    type: LOGOUT_SUCCESS
  }
}

export function signoutApi () {
  return (dispatch, getState) => {
    commonFetch(
      api.LOGOUT_API,
      'POST',
      null,
      null,
      json => { dispatch(logoutSuccess()); hashHistory.replace('/login') },
      null
    )
  }
}

export function whoamiApi (value) {
  return (dispatch, getState) => {
    commonFetch(
      api.WHO_AM_I,
      'GET',
      null,
      () => dispatch(whoamiRequest()),
      json => dispatch(whoamiSuccess(json)),
      err => {
        !err.message && (err.message = 'Authentication failed.')
        dispatch(whoamiFail(err))
        hashHistory.replace('/login')
      }
    )
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const changeCredential = (state, action) => {
  return {
    ...state,
    role: action.payload.role,
    username: action.payload.username
  }
}
const requestCredential = (state, action) => {
  return {
    ...state,
    isFetching: true
  }
}
const successCredential = (state, action) => {
  console.log('in successCredential, %o', action.payload)
  return {
    ...state,
    role: action.payload.role,
    username: action.payload.username,
    isFetching: false
  }
}
const failCredential = (state, action) => {
  return {
    ...state,
    isFetching: false,
    username: '',
    role: null,
    error: {
      ...state.error,
      api: action.payload.message
    }
  }
}

const doLogoutSuccess = (state, action) => {
  return initialState
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREDENTIAL_CHANGE]: changeCredential,
  [CREDENTIAL_REQUEST]: requestCredential,
  [CREDENTIAL_SUCCESS]: successCredential,
  [CREDENTIAL_FAIL]: failCredential,
  [LOGOUT_SUCCESS]: doLogoutSuccess
}

const initialState = {
  username: '',
  role: '',
  isFetching: false,
  error: {}
}

export default function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/credential.js